/* FOCUS · LANDING V2 — bloque de compra.
   Misma lógica de venta que la V1: el formulario es el {% form 'product' %}
   de Shopify, el pack solo cambia la CANTIDAD que se añade al carrito y el
   precio final lo aplican los descuentos automáticos de la tienda.
   Aquí no hay ningún checkout simulado. */
(function () {
  'use strict';

  // Mismo cerrojo que fev2.js: una sola inicialización por página.
  if (window.__fev2CompraIniciado) return;
  window.__fev2CompraIniciado = true;

  function $(id) { return document.getElementById(id); }
  function todos(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function salta(el) {
    if (!el) return;
    el.classList.remove('v2-precio--cambia');
    void el.offsetWidth;
    el.classList.add('v2-precio--cambia');
  }

  function formateaPrecio(centimos) {
    if (window.feMercado && window.feMercado.moneda === 'MXN') {
      return '$' + Math.round(Math.abs(Number(centimos) || 0) / 100).toLocaleString('es-MX');
    }
    return (centimos / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* ---------------------------------------------------------------- galería */
  function initGaleria() {
    var gal = document.querySelector('[data-v2-gal]');
    var principal = $('v2-gal-principal');
    var minis = todos('.v2-gal__mini', gal || document);
    if (!principal || !minis.length) return;

    var indice = 0;
    var puntosCaja = gal ? gal.querySelector('[data-v2-gal-puntos]') : null;

    function mostrar(i, suave) {
      if (i < 0) i = minis.length - 1;
      if (i >= minis.length) i = 0;
      indice = i;
      var mini = minis[i];
      var src = mini.getAttribute('data-v2-img');
      if (src) principal.src = src;
      var alt = mini.getAttribute('data-v2-alt');
      if (alt !== null) principal.alt = alt;
      minis.forEach(function (m, n) {
        m.classList.toggle('v2-activa', n === i);
        m.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
      if (puntosCaja) {
        todos('button', puntosCaja).forEach(function (p, n) {
          p.classList.toggle('v2-activa', n === i);
        });
      }
      var tira = mini.parentElement;
      if (tira && tira.scrollWidth > tira.clientWidth) {
        var dest = mini.offsetLeft - (tira.clientWidth - mini.offsetWidth) / 2;
        if (suave && tira.scrollTo) tira.scrollTo({ left: dest, behavior: 'smooth' });
        else tira.scrollLeft = dest;
      }
    }

    minis.forEach(function (mini, i) {
      mini.addEventListener('click', function () { mostrar(i, true); });
    });

    if (puntosCaja && minis.length > 1) {
      puntosCaja.hidden = false;
      puntosCaja.innerHTML = '';
      minis.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'v2-gal__punto' + (i === 0 ? ' v2-activa' : '');
        b.setAttribute('aria-label', 'Foto ' + (i + 1));
        b.addEventListener('click', function () { mostrar(i, true); });
        puntosCaja.appendChild(b);
      });
    }

    if (gal) {
      todos('[data-v2-gal-dir]', gal).forEach(function (btn) {
        btn.addEventListener('click', function () {
          mostrar(indice + parseInt(btn.getAttribute('data-v2-gal-dir'), 10), true);
        });
      });
      if (minis.length < 2) {
        todos('.v2-gal__flecha', gal).forEach(function (b) { b.hidden = true; });
      }
    }

    var escena = gal ? gal.querySelector('.v2-gal__escena') : principal.parentElement;
    var toque = null;
    if (escena) {
      escena.addEventListener('touchstart', function (e) {
        if (!e.changedTouches || !e.changedTouches[0]) return;
        toque = { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY };
      }, { passive: true });
      escena.addEventListener('touchend', function (e) {
        if (!toque || !e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - toque.x;
        var dy = e.changedTouches[0].clientY - toque.y;
        toque = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        mostrar(indice + (dx < 0 ? 1 : -1), true);
      }, { passive: true });
    }

    mostrar(0, false);
  }

  /* -------------------------------------------------------------- variantes */
  function initVariantes() {
    var datos = $('v2-variantes');
    var inputId = $('v2-variante-id');
    var grupos = todos('[data-v2-opcion-indice]');
    if (!datos || !inputId || !grupos.length) return;

    var variantes;
    try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
    if (!variantes || !variantes.length) return;

    var boton = $('v2-boton');
    var botonBarra = $('v2-barra-boton');
    var textoDisponible = boton ? boton.textContent.trim() : '';
    var textoAgotado = boton ? boton.getAttribute('data-agotado') || 'AGOTADO' : 'AGOTADO';
    var principal = $('v2-gal-principal');
    var minis = todos('.v2-gal__mini');

    function muestraMedia(mediaId) {
      if (!principal || !mediaId || !minis.length) return;
      var destino = null;
      minis.forEach(function (m) {
        if (m.getAttribute('data-v2-media-id') === String(mediaId)) destino = m;
      });
      if (!destino) return;
      var src = destino.getAttribute('data-v2-img');
      if (src && principal.getAttribute('src') !== src) principal.src = src;
      minis.forEach(function (m) { m.classList.remove('v2-activa'); });
      destino.classList.add('v2-activa');
      var tira = destino.parentElement;
      if (tira && tira.scrollWidth > tira.clientWidth) {
        tira.scrollLeft = destino.offsetLeft - (tira.clientWidth - destino.offsetWidth) / 2;
      }
    }

    function elegidas() {
      return grupos.map(function (g) {
        var activa = g.querySelector('.v2-opcion__valor.v2-activa');
        return activa ? activa.getAttribute('data-v2-valor') : null;
      });
    }

    function actualiza() {
      var valores = elegidas();
      var match = variantes.find(function (v) {
        return valores.every(function (val, i) { return v.options[i] === val; });
      });
      if (!match) return;

      inputId.value = match.id;

      grupos.forEach(function (g) {
        var eco = g.querySelector('[data-v2-opcion-eco]');
        var activa = g.querySelector('.v2-opcion__valor.v2-activa');
        if (eco && activa) eco.textContent = activa.getAttribute('data-v2-valor');
      });

      if (match.featured_media && match.featured_media.id) muestraMedia(match.featured_media.id);

      [boton, botonBarra].forEach(function (b) {
        if (!b) return;
        b.disabled = !match.available;
        b.textContent = match.available ? textoDisponible : textoAgotado;
      });
    }

    grupos.forEach(function (g) {
      todos('.v2-opcion__valor', g).forEach(function (btn) {
        btn.addEventListener('click', function () {
          todos('.v2-opcion__valor', g).forEach(function (o) {
            o.classList.remove('v2-activa');
            o.setAttribute('aria-checked', 'false');
          });
          btn.classList.add('v2-activa');
          btn.setAttribute('aria-checked', 'true');
          actualiza();
        });
      });
    });

    actualiza();
  }

  function pintaPremioPack(cantidad, animar) {
    var n = parseInt(cantidad, 10) || 0;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    todos('[data-v2-premio-pack]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-v2-pack-min') || '4', 10);
      var abierto = n >= min;
      var estabaBloqueada = el.classList.contains('v2-insignia--bloqueada');
      if (el._fePremioFlip) {
        clearTimeout(el._fePremioFlip);
        el._fePremioFlip = 0;
      }

      if (!animar || reduce) {
        el.classList.remove('v2-insignia--abre', 'v2-insignia--cierra');
        el.classList.toggle('v2-insignia--bloqueada', !abierto);
        return;
      }

      var debeAbrir = abierto && estabaBloqueada;
      var debeCerrar = !abierto && !estabaBloqueada;
      if (!debeAbrir && !debeCerrar) return;

      el.classList.remove('v2-insignia--abre', 'v2-insignia--cierra');
      void el.offsetWidth;
      el.classList.add(debeAbrir ? 'v2-insignia--abre' : 'v2-insignia--cierra');
      el._fePremioFlip = setTimeout(function () {
        el._fePremioFlip = 0;
        el.classList.toggle('v2-insignia--bloqueada', !abierto);
      }, 240);
      el.addEventListener('animationend', function limpia(ev) {
        if (ev.target !== el) return;
        el.removeEventListener('animationend', limpia);
        el.classList.remove('v2-insignia--abre', 'v2-insignia--cierra');
      });
    });
  }

  /* ------------------------------------------------------------------ packs */
  function initPacks() {
    var radios = todos('.v2-pack__radio');
    var cantidad = $('v2-cantidad');
    if (!radios.length || !cantidad) return;

    var precioEl = $('v2-precio');
    var antesEl = $('v2-precio-antes');
    var barraPrecio = $('v2-barra-precio');
    var barraAntes = $('v2-barra-antes');
    var barraPack = $('v2-barra-pack-nombre');
    var barraOpciones = todos('[data-v2-barra-pack]');
    var primeraVez = true;

    function actualiza() {
      var elegido = document.querySelector('.v2-pack__radio:checked');
      if (!elegido) return;

      cantidad.value = elegido.value;

      radios.forEach(function (r) {
        var tarjeta = r.closest('.v2-pack');
        if (!tarjeta) return;
        var yaActiva = tarjeta.classList.contains('v2-pack--activo');
        tarjeta.classList.toggle('v2-pack--activo', r.checked);
        if (r.checked && !yaActiva) {
          tarjeta.classList.remove('v2-pack--golpe');
          void tarjeta.offsetWidth;
          tarjeta.classList.add('v2-pack--golpe');
        }
      });

      var precio = elegido.getAttribute('data-precio');
      var antes = elegido.getAttribute('data-precio-antes');

      if (precioEl && precio) {
        precioEl.textContent = precio;
        if (!primeraVez) salta(precioEl);
      }
      if (antesEl) {
        antesEl.textContent = antes || '';
        antesEl.style.display = antes ? '' : 'none';
      }
      if (barraPrecio && precio) {
        barraPrecio.textContent = precio;
        if (!primeraVez) salta(barraPrecio);
      }
      if (barraAntes) {
        barraAntes.textContent = antes || '';
        barraAntes.hidden = !antes;
      }
      if (barraPack) {
        var nombre = elegido.closest('.v2-pack').querySelector('.v2-pack__nombre');
        if (nombre) barraPack.textContent = nombre.textContent.trim();
      }
      barraOpciones.forEach(function (o) {
        o.classList.toggle('v2-barra__opcion--activa', o.getAttribute('data-v2-barra-pack') === elegido.value);
      });

      pintaPremioPack(elegido.value, !primeraVez);
      if (typeof window.__fev2PintaTallasPack === 'function') {
        window.__fev2PintaTallasPack(parseInt(elegido.value, 10) || 1);
      }

      primeraVez = false;
    }

    radios.forEach(function (r) { r.addEventListener('change', actualiza); });
    todos('.v2-pack__elige').forEach(function (elige) {
      elige.addEventListener('click', function () {
        var radio = elige.querySelector('.v2-pack__radio');
        if (!radio || radio.checked) return;
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    // Desde el desplegable de la barra se marca el radio de verdad: una sola
    // fuente de la cantidad que se añade al carrito.
    barraOpciones.forEach(function (o) {
      o.addEventListener('click', function () {
        var destino = document.querySelector('.v2-pack__radio[value="' + o.getAttribute('data-v2-barra-pack') + '"]');
        if (!destino || destino.checked) return;
        destino.checked = true;
        destino.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    actualiza();
  }

  /* Una talla (edad) por almohada, dentro de la tarjeta del pack activo. */
  function initPackTallas() {
    var caja = document.querySelector('[data-v2-pack-tallas]');
    var datos = $('v2-variantes');
    var inputId = $('v2-variante-id');
    var campoItems = $('v2-pack-items');
    if (!caja || !datos) return;

    var variantes;
    try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
    if (!variantes || !variantes.length) return;

    var memoria = [];
    var hayPack = variantes.some(function (v) {
      return v.options && v.options.length >= 3;
    });

    function idDeEdadYPack(edad, pack) {
      var p = String(pack || '1');
      var match = variantes.find(function (v) {
        if (!v.options || v.options[0] !== edad) return false;
        if (!hayPack) return true;
        return String(v.options[2] || '1') === p;
      });
      if (match) return String(match.id);
      match = variantes.find(function (v) {
        return v.options && v.options[0] === edad;
      }) || variantes.find(function (v) { return v.title === edad; });
      return match ? String(match.id) : null;
    }

    function leeTarjeta(tarjeta) {
      return todos('[data-v2-edad]', tarjeta).map(function (sel) {
        return sel.value;
      });
    }

    function aplicaMemoria(tarjeta) {
      todos('[data-v2-edad]', tarjeta).forEach(function (sel, i) {
        if (memoria[i]) sel.value = memoria[i];
      });
    }

    function escribePedido() {
      var radio = document.querySelector('.v2-pack__radio:checked');
      var activo = radio ? radio.closest('.v2-pack') : document.querySelector('.v2-pack--activo');
      if (!activo) return;
      var valores = leeTarjeta(activo);
      memoria = valores.slice();
      // Cada talla elegida = una unidad real. Se añade una línea por talla
      // (variante real, SKU real); las tallas iguales se agrupan en cantidad.
      // El precio de pack lo aplica el descuento automático de la tienda.
      var porId = {};
      var orden = [];
      valores.forEach(function (edad) {
        var id = idDeEdadYPack(edad, '1');
        if (!id) return;
        if (!porId[id]) { porId[id] = 0; orden.push(id); }
        porId[id] += 1;
      });
      var items = orden.map(function (id) {
        return { id: id, quantity: porId[id] };
      });
      if (!items.length) return;
      if (campoItems) campoItems.value = JSON.stringify(items);
      if (inputId) inputId.value = items[0].id;
      var qtyInput = $('v2-cantidad');
      if (qtyInput) qtyInput.value = String(valores.length || 1);
    }

    function pinta(n) {
      todos('.v2-pack').forEach(function (tarjeta) {
        var radio = tarjeta.querySelector('.v2-pack__radio');
        var edades = tarjeta.querySelector('[data-v2-pack-edades]');
        if (!edades) return;
        var activo = radio && radio.checked;
        edades.hidden = !activo;
        if (activo) aplicaMemoria(tarjeta);
      });
      escribePedido();
    }

    todos('[data-v2-pack-edades]').forEach(function (edades) {
      edades.addEventListener('click', function (e) { e.stopPropagation(); });
      edades.addEventListener('mousedown', function (e) { e.stopPropagation(); });
      todos('[data-v2-edad]', edades).forEach(function (sel) {
        sel.addEventListener('change', function () {
          var tarjeta = sel.closest('.v2-pack');
          if (tarjeta) memoria = leeTarjeta(tarjeta);
          escribePedido();
        });
      });
    });

    var radioIni = document.querySelector('.v2-pack__radio:checked');
    var tarjetaIni = radioIni ? radioIni.closest('.v2-pack') : null;
    if (tarjetaIni) memoria = leeTarjeta(tarjetaIni);

    window.__fev2PintaTallasPack = pinta;
    pinta(radioIni ? parseInt(radioIni.value, 10) || 1 : 1);
  }

  /* ------------------------------------------------------------- barra fija */
  function initBarra() {
    var barra = $('v2-barra');
    var boton = $('v2-boton');
    if (!barra || !boton) return;

    if (barra.parentElement !== document.body) document.body.appendChild(barra);

    var siempre = barra.getAttribute('data-v2-siempre') === '1';
    var resenasId = barra.getAttribute('data-v2-resenas');
    var resenas = resenasId ? $(resenasId) : document.querySelector('#v2-comprar [id^="v2-resena-"]');
    var tick = false;

    function umbralResenas() {
      if (!resenas) return 0;
      return Math.max(0, resenas.offsetTop - window.innerHeight + 140);
    }

    function revisa() {
      var mostrar = false;

      if (resenas) {
        mostrar = window.scrollY >= umbralResenas();
      } else if (siempre) {
        mostrar = window.scrollY > 200;
      } else {
        mostrar = boton.getBoundingClientRect().bottom < 0;
      }

      barra.classList.toggle('v2-barra--visible', mostrar);
      barra.setAttribute('aria-hidden', mostrar ? 'false' : 'true');
      if (!mostrar) cierraPacks();
      document.body.classList.toggle('v2-barra-activa', mostrar);
    }

    function pideRevisa() {
      if (tick) return;
      tick = true;
      requestAnimationFrame(function () {
        tick = false;
        revisa();
      });
    }


    /* --------------------------------------------- desplegable de packs */
    var selector = $('v2-barra-selector');
    var lista = $('v2-barra-packs');

    function cierraPacks() {
      if (!selector || !lista || lista.hidden) return;
      lista.hidden = true;
      selector.setAttribute('aria-expanded', 'false');
    }

    if (selector && lista) {
      selector.addEventListener('click', function () {
        var abierto = !lista.hidden;
        lista.hidden = abierto;
        selector.setAttribute('aria-expanded', abierto ? 'false' : 'true');
      });
      // Elegir pack cierra: el visitante ya tiene lo que venía a buscar.
      todos('[data-v2-barra-pack]', lista).forEach(function (o) {
        o.addEventListener('click', cierraPacks);
      });
      document.addEventListener('click', function (e) {
        if (!barra.contains(e.target)) cierraPacks();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') cierraPacks();
      });
    }

    window.addEventListener('scroll', pideRevisa, { passive: true });
    window.addEventListener('resize', pideRevisa);
    // Las fotos entran tarde y mueven el botón sin generar evento de scroll:
    // sin estos repasos la barra se quedaría con el estado de antes del reflow.
    window.addEventListener('load', pideRevisa);
    if ('ResizeObserver' in window) new ResizeObserver(pideRevisa).observe(boton);
    revisa();
  }

  /* Flecha flotante: vuelve a los packs al bajar por otras secciones. */
  function initIrPacks() {
    var btn = $('v2-ir-packs');
    var packs = $('v2-packs');
    var barra = $('v2-barra');
    if (!btn || !packs) return;

    if (btn.parentElement !== document.body) document.body.appendChild(btn);

    var resenasId = barra ? barra.getAttribute('data-v2-resenas') : '';
    var resenas = resenasId ? $(resenasId) : document.querySelector('#v2-comprar [id^="v2-resena-"]');
    var tick = false;

    function umbralResenas() {
      if (!resenas) return 0;
      return Math.max(0, resenas.offsetTop - window.innerHeight + 140);
    }

    function revisa() {
      var mostrar = false;
      if (resenas && window.scrollY >= umbralResenas()) {
        var pr = packs.getBoundingClientRect();
        mostrar = pr.bottom < 80 || pr.top > window.innerHeight - 80;
      }
      btn.hidden = !mostrar;
      btn.classList.toggle('v2-ir-packs--visible', mostrar);
    }

    function pideRevisa() {
      if (tick) return;
      tick = true;
      requestAnimationFrame(function () {
        tick = false;
        revisa();
      });
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      packs.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    window.addEventListener('scroll', pideRevisa, { passive: true });
    window.addEventListener('resize', pideRevisa);
    window.addEventListener('load', pideRevisa);
    revisa();
  }

  /* Al añadir abrimos el cajón. El envío lo coge el interceptor global
     (fe-carrito.js) para no esperar a que Shopify pinte el HTML. Aquí solo
     se enseña el error si el carrito lo rechaza. */
  function initCarritoLateral() {
    document.addEventListener('fev2:carrito', function (ev) {
      var caja = $('v2-error');
      if (!caja) return;
      if (!ev.detail || ev.detail.ok || !ev.detail.mensaje) {
        caja.textContent = '';
        caja.hidden = true;
        return;
      }
      caja.textContent = ev.detail.mensaje;
      caja.hidden = false;
    });
  }

  /* --------------------------------------------- carrusel de reseñas */
  // Una reseña visible a la vez, puntos para saltar y giro automático.
  function initResena() {
    todos('[data-v2-resena]').forEach(function (caja) {
      var slides = todos('[data-v2-resena-slide]', caja);
      var puntos = todos('[data-v2-resena-punto]', caja);
      if (slides.length < 2) return;
      var actual = 0;
      var espera = (parseFloat(caja.dataset.v2Auto) || 6) * 1000;
      var reloj = null;

      function muestra(i) {
        actual = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) {
          var activa = n === actual;
          s.classList.toggle('v2-oculta', !activa);
          if (activa) { s.removeAttribute('aria-hidden'); } else { s.setAttribute('aria-hidden', 'true'); }
        });
        puntos.forEach(function (p, n) {
          var activo = n === actual;
          p.classList.toggle('v2-activa', activo);
          if (activo) { p.setAttribute('aria-current', 'true'); } else { p.removeAttribute('aria-current'); }
        });
      }

      function arrancaGiro() { para(); reloj = setInterval(function () { muestra(actual + 1); }, espera); }
      function para() { if (reloj) { clearInterval(reloj); reloj = null; } }

      puntos.forEach(function (p, n) {
        p.addEventListener('click', function () { muestra(n); arrancaGiro(); });
      });
      caja.addEventListener('mouseenter', para);
      caja.addEventListener('mouseleave', arrancaGiro);

      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) arrancaGiro();
    });
  }

  /* --------------------------------------------- contador de la oferta */
  // El texto sale siempre. El reloj solo cuando el visitante ha añadido
  // al carrito (mismo estado que el cajón). Antes de eso no se inventa
  // una cuenta atrás.
  function initCuentaAtras() {
    var caja = document.getElementById('v2-cuenta');
    var reloj = document.getElementById('v2-cuenta-reloj');
    var texto = caja ? caja.querySelector('.v2-cuenta__texto') : null;
    if (!caja || !reloj) return;

    var base = caja.getAttribute('data-texto') || (texto ? texto.textContent : '') || 'Tu oferta está reservada';

    function dosDigitos(n) { return n < 10 ? '0' + n : String(n); }

    function pinta() {
      if (!window.feOfertaTiempo) return;
      var estado = window.feOfertaTiempo.tick();
      caja.classList.toggle('v2-cuenta--espera', estado.pendiente);
      caja.classList.toggle('v2-cuenta--aviso', estado.fase === 'aviso');
      caja.classList.toggle('v2-cuenta--urgente', estado.fase === 'urgente' || estado.fase === 'critico');
      caja.classList.toggle('v2-cuenta--cero', estado.cero);
      if (texto) {
        texto.textContent = (estado.fase === 'espera' || estado.fase === 'normal')
          ? base
          : estado.titulo;
      }
      reloj.textContent = estado.pendiente
        ? ''
        : dosDigitos(Math.floor(estado.segundos / 60)) + ':' + dosDigitos(estado.segundos % 60);
    }

    pinta();
    setInterval(pinta, 1000);
    document.addEventListener('fev2:oferta', pinta);
    document.addEventListener('fev2:carrito', pinta);
  }

  /* ----------------------------- barra de stock bajo los packs */
  function initStockBar() {
    var caja = document.getElementById('v2-stock');
    var lleno = document.getElementById('v2-stock-lleno');
    var pctEl = document.getElementById('v2-stock-pct');
    if (!caja || !lleno || !pctEl) return;

    var inicio = parseFloat(caja.getAttribute('data-inicio')) || 85;
    var fin = parseFloat(caja.getAttribute('data-fin')) || 93;
    if (fin < inicio) fin = inicio;
    var duracion = (parseFloat(caja.getAttribute('data-duracion')) || 55) * 1000;

    function pinta(pct) {
      var v = Math.round(Math.max(0, Math.min(99, pct)));
      lleno.style.width = v + '%';
      pctEl.textContent = String(v);
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      pinta(fin);
      return;
    }

    pinta(inicio);

    var arrancado = false;
    function animar() {
      if (arrancado) return;
      arrancado = true;
      var t0 = null;
      function sube(ts) {
        if (!t0) t0 = ts;
        var t = Math.min(1, (ts - t0) / duracion);
        var ease = 1 - Math.pow(1 - t, 3);
        pinta(inicio + (fin - inicio) * ease);
        if (t < 1) {
          requestAnimationFrame(sube);
          return;
        }
        var techo = Math.min(97, fin + 3);
        var t1 = null;
        function creep(ts2) {
          if (!t1) t1 = ts2;
          var t2 = Math.min(1, (ts2 - t1) / 90000);
          pinta(fin + (techo - fin) * t2);
          if (t2 < 1) requestAnimationFrame(creep);
        }
        requestAnimationFrame(creep);
      }
      requestAnimationFrame(sube);
    }

    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            animar();
            obs.disconnect();
          }
        });
      }, { threshold: 0.25 });
      obs.observe(caja);
    } else {
      animar();
    }
  }

  // "Ver más preguntas": revela el resto de la FAQ sin recargar.
  function initFaqMas() {
    todos('[data-v2-faq-mas]').forEach(function (btn) {
      var caja = $(btn.getAttribute('data-v2-faq-mas'));
      if (!caja) return;
      btn.addEventListener('click', function () {
        todos('.v2-faq__item--oculta', caja).forEach(function (item) {
          item.classList.remove('v2-faq__item--oculta');
        });
        btn.parentNode.removeChild(btn);
      });
    });
  }

  function arranca() {
    initGaleria();
    initVariantes();
    initPackTallas();
    initPacks();
    initBarra();
    initIrPacks();
    initResena();
    initCarritoLateral();
    initCuentaAtras();
    initStockBar();
    initFaqMas();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca, { once: true });
  } else {
    arranca();
  }
})();
